// extracted by mini-css-extract-plugin
export default {"productDescription":"Saa-z","featuredDescription":"Taa-z","description":"Uaa-z","more":"Vaa-z","descriptionSku":"Waa-z"};